<!-- Custom Footer Portal Template if provided -->
<ng-container *ngIf="footerPortal$ | async as customFooter; else defaultFooter">
  <ng-container *ngTemplateOutlet="customFooter"></ng-container>
</ng-container>

<!-- Default Copyright Footer -->
<ng-template #defaultFooter>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT &copy; {{ year }}
      <a class="ml-25" href="https://cmcati.vn/" target="_blank">CMC ATI</a>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>
    <span class="float-md-right d-none d-md-block">
      Made by Newtech department
      <span [data-feather]="'heart'" [class]="'pink'"></span>
    </span>
  </p>
</ng-template>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>

<!-- Buynow Button-->
